import React, { useRef, useEffect } from 'react';

import './Map.css';

const Map = props => {
    const mapRef = useRef();

    // Destructuring props for cleaner dependency tracking
    const { center, zoom } = props;

    useEffect(() => {
        // This creates the map inside the div with id="map"
        if (window.ol) {
            new window.ol.Map({
                target: mapRef.current.id,  // OpenLayers looks for this ID
                layers: [
                    new window.ol.layer.Tile({
                        source: new window.ol.source.OSM()   // Uses OpenStreetMap
                    })
                ],
                view: new window.ol.View({
                    // OpenLayers uses [Lon, Lat], whereas we stored [Lat, Lng]
                    center: window.ol.proj.fromLonLat([center.lng, center.lat]),
                    zoom: zoom
                })
            });
        }
    }, [center, zoom]);

    return (
        <div
            ref={mapRef}
            className={`map ${props.className}`}
            style={props.style}
            id="map"
        ></div>
    );
};

export default Map;